export enum InteractionMode {
    NORMAL = 'normal',
    WIRE_CREATION = 'wire_creation',
    NODE_ASSIGNMENT = 'node_assignment',
    BUNDLE_DRAG = 'bundle_drag'
  }
  
  export enum MouseButton {
    LEFT = 0,
    MIDDLE = 1,
    RIGHT = 2
  }
  
  export enum KeyCode {
    ESCAPE = 'Escape',
    DELETE = 'Delete',
    BACKSPACE = 'Backspace'
  }